module.exports = __webpack_public_path__ + "cx.svg?8142eab77f7fe4cfb349a14b4f94ce1d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/cx.svg
// module id = 1062
// module chunks = 0